import React from "react";
import { EyeIcon } from "@heroicons/react/24/outline";

export const HighContrastToggle: React.FC<{ className?: string }> = ({ className = "" }) => {
  const [enabled, setEnabled] = React.useState<boolean>(
    document.documentElement.classList.contains("high-contrast"),
  );

  const toggle = () => {
    setEnabled((prev) => {
      const next = !prev;
      document.documentElement.classList.toggle("high-contrast", next);
      localStorage.setItem("accessibility.highContrast", next ? "1" : "0");
      return next;
    });
  };

  React.useEffect(() => {
    const saved = localStorage.getItem("accessibility.highContrast");
    if (saved === "1") {
      document.documentElement.classList.add("high-contrast");
      setEnabled(true);
    }
  }, []);

  return (
    <button
      type="button"
      onClick={toggle}
      className={`inline-flex items-center gap-2 px-3 py-2 rounded-lg border text-sm ${
        enabled
          ? "border-yellow-500 text-yellow-700 bg-yellow-50"
          : "border-gray-300 text-gray-700 bg-white hover:bg-gray-50"
      } ${className}`}
      aria-pressed={enabled}
      aria-label="Toggle high contrast mode"
    >
      <EyeIcon className="h-5 w-5" />
      {enabled ? "High Contrast On" : "High Contrast Off"}
    </button>
  );
};

export default HighContrastToggle;
